<template>
    <div class="lectureS">
        <h2>法律讲座</h2>
        <div class="lectureE">
            <!--<div class="con">-->
                <div class="cont" v-for="item in moveList">
                    <div class="image" :style="{'background': 'url('+item.image+') no-repeat center center'}">
                        <p>{{item.title}}</p>
                        <p>{{item.name}}</p>
                    </div>
                    <p class="textP">{{item.company}}</p>
                    <div class="times">
                        <i :style="{'background':'url('+item.icon+') no-repeat center center'}"></i>
                        <span>{{item.times}}</span>
                    </div>

                </div>
            <!--</div>-->


        </div>
        <div class="gdfw">
            <h2>彩虹律师高端服务</h2>
        </div>
    </div>
</template>

<script>
    export default {
        name: "lecture",
        data(){
            return{
                moveList:[
                    {
                        image:require('../assets/img/banner3.png'),
                        title:'广告法解析',
                        name:'虚假广告解读及案例分析',
                        company:'彩虹律师广告法解读(上海)',
                        icon:require('../assets/img/timee.png'),
                        times:'2018-01-12'
                    },
                    {
                        image:require('../assets/img/banner3.png'),
                        title:'劳资关系沙龙讲座',
                        name:'劳动关系解除技巧',
                        company:'彩虹律师劳资关系沙龙讲座(上海)',
                        icon:require('../assets/img/timee.png'),
                        times:'2018-01-19'
                    }
                ]
            }
        }
    }
</script>

<style lang="less" scoped>
.lectureS{
    width: 100%;
    height: 780px;
    padding-top:40px;
    background: rgb(248,248,248);
    h2{
        font-size: 30px;
        text-align: center;
        padding-top: 40px;
        padding-bottom:20px;
    }
    .lectureE{
        width: 1164px;
        height: 430px;
        margin: 0 auto;
        /*background: yellow;*/
        display: flex;
        justify-content: space-around; /* 分布居中 */
        align-items: center;     /* 垂直居中 */
        .cont{
            height: 250px;
            width: 415px;
            background: white;
            box-shadow: 0 5px 21px 0 rgba(3,20,58,0.14);
            padding: 50px 64px 92px 64px;
            .image{
                width: 415px;
                height: 250px;
                p{
                    text-align: center;
                }
                p:nth-child(1){
                    padding-top: 86px;
                    font-size: 30px;
                    color: rgb(246,191,72);
                }
                p:nth-child(2){
                    padding-top: 18px;
                    font-size: 24px;
                    color: rgb(255,255,255);
                }
            }
            .textP{
                padding-top:20px;
                font-size: 20px;
                color: rgb(51,51,51);
            }
            .times{
                margin-top: 12px;
                position: relative;
                i{
                    line-height: 18px;
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    left: 0;
                    top: 1px;
                }
                span{
                    padding-left: 38px;
                    font-size: 16px;
                    line-height: 18px;
                    color: rgb(153,153,153);
                }
            }
        }

    }
    .gdfw{
        margin-top:80px;
        width: 100%;
        height: 200px;
        background: url("../assets/img/banner4.png") no-repeat;
        background-size: cover;
        h2{
            line-height:100px;
            font-size: 42px;
            color: rgb(255,255,255);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/lecture.vue